import styled from "styled-components";
import JIDRCurrencyIconSrc from "../../assets/icons/JIDRCurrency.svg";
import JIDRCurrencyPngSrc from "../../assets/images/JIDRCurrency.png";

export const JIDRCurrency = styled.img.attrs({
  src: JIDRCurrencyIconSrc
})``

export const JIDRCurrencyPng = styled.img.attrs({
  src: JIDRCurrencyPngSrc
})``
